(() => {
  const t = (i18n, key, fallback) =>
    (i18n && i18n[key] != null && String(i18n[key]).trim() !== '' && !String(i18n[key]).startsWith('translation missing'))
      ? i18n[key]
      : fallback;

  const cartAddUrl = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root}cart/add.js`;
  };

  const norm = (s) =>
    String(s || '')
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/×/g, 'x')
      .replace(/\s+/g, ' ')
      .trim();

  const includesAny = (hay, needles) => {
    if (!needles || !needles.length) return false;
    const h = norm(hay);
    return needles.some((n) => h.includes(norm(n)));
  };

  const excludesAny = (hay, needles) => {
    if (!needles || !needles.length) return true;
    const h = norm(hay);
    return !needles.some((n) => h.includes(norm(n)));
  };

    const formatMoney = (cents, _moneyFormat) => {
    if (cents == null || cents === '') return '—';
    const n = Number(cents);
    if (Number.isNaN(n)) return '—';
    const whole = Math.round(n / 100);
    return `${whole.toLocaleString('tr-TR')} ₺`;
  };

  const moneyOf = (variant, moneyFormat) => {
    if (!variant) return '—';
    return formatMoney(variant.price, moneyFormat);
  };

  const cartSectionIds = () =>
    Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : null))
      .filter(Boolean);

  const notifyHorizonCart = async (addResponse, lines) => {
    let cartJson = null;
    try {
      cartJson = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      }).then((r) => r.json());
    } catch (_) {}
    try {
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      const deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: lines || [],
          promise: deferred.promise,
        })
      );
      deferred.resolve({
        cart: cartJson ? CartLinesUpdateEvent.createCartFromAjaxResponse(cartJson) : undefined,
        detail: {
          items: cartJson?.items || [],
          source: 'cube-craft',
          itemCount: cartJson?.item_count,
          sections: addResponse?.sections || {},
          didError: false,
        },
      });
    } catch (err) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cartJson || addResponse, bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartJson || addResponse, bubbles: true }));
    }
  };

  class CubeCraft extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const cfgEl = document.getElementById(this.dataset.configId || '');
      if (!cfgEl) return;
      try {
        this.config = JSON.parse(cfgEl.textContent);
      } catch (e) {
        console.error('[CubeCraft] bad config', e);
        return;
      }

      this.i18n = this.config.i18n || {};
      this.variants = this.config.variants || [];
      this.options = this.config.options || [];
      this.moneyFormat = this.config.moneyFormat || '{{amount}} ₺';
      this.environment = this.options[0]?.environment || 'indoor';
      const first = this.options.find((o) => o.environment === this.environment) || this.options[0];
      this.optionId = first?.id || null;

      this._cacheDom();
      this._renderEnvPills();
      this._renderModelPills();
      this._bind();
      this._markHosts();
      this._interceptCart();
      this._sync();
    }

    _cacheDom() {
      this.envPills = this.querySelector('[data-cb-envs]');
      this.modelPills = this.querySelector('[data-cb-models]');
      this.descEl = this.querySelector('[data-cb-desc]');
      this.basePriceEl = this.querySelector('[data-cb-base-price]');
      this.totalEl = this.querySelector('[data-cb-total]');
      this.statusEl = this.querySelector('[data-cb-status]');
    }

    _optionsForEnv(env) {
      return this.options.filter((o) => o.environment === env);
    }

    _renderEnvPills() {
      if (!this.envPills) return;
      this.envPills.innerHTML = '';
      const envs = [
        { id: 'indoor', label: t(this.i18n, 'indoor', 'İç mekan') },
        { id: 'outdoor', label: t(this.i18n, 'outdoor', 'Dış mekan') },
      ];
      envs.forEach((env) => {
        if (!this._optionsForEnv(env.id).length) return;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cube-craft__pill';
        btn.setAttribute('data-cb-env', env.id);
        btn.setAttribute('aria-pressed', 'false');
        btn.textContent = env.label;
        this.envPills.appendChild(btn);
      });
    }

    _renderModelPills() {
      if (!this.modelPills) return;
      this.modelPills.innerHTML = '';
      this._optionsForEnv(this.environment).forEach((opt) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cube-craft__pill';
        btn.setAttribute('data-cb-model', opt.id);
        btn.setAttribute('aria-pressed', 'false');
        btn.innerHTML = `<span>${opt.label}</span><span class="cube-craft__pill-meta">${opt.sizeLabel || ''}</span>`;
        this.modelPills.appendChild(btn);
      });
    }

    _bind() {
      this.envPills?.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-cb-env]');
        if (!btn) return;
        this.environment = btn.getAttribute('data-cb-env');
        const first = this._optionsForEnv(this.environment)[0];
        this.optionId = first?.id || null;
        this._renderModelPills();
        this._sync();
      });
      this.modelPills?.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-cb-model]');
        if (!btn) return;
        this.optionId = btn.getAttribute('data-cb-model');
        this._sync();
      });
    }

    _markHosts() {
      document.querySelectorAll('product-info, .product, .product-information').forEach((el) => {
        el.classList.add('product--cubecraft');
        const boot = () => { if (window.HarfmixCraftPdp) { window.HarfmixCraftPdp.init({ quoteOnly: false }); return true; } return false; };
        if (!boot()) [50, 200, 600, 1500].forEach((ms) => setTimeout(boot, ms));
      });
    }

    _interceptCart() {
      const isOurAtcButton = (el) => {
        if (!(el instanceof Element)) return false;
        const btn = el.closest('button[type="submit"], button[name="add"], [name="add"]');
        if (!btn || btn.closest('cube-craft')) return false;
        return (
          document.body.contains(this) &&
          !!btn.closest('sticky-add-to-cart, .sticky-add-to-cart, product-form, .product-form, form[action*="/cart/add"]')
        );
      };
      const guard = (event) => {
        if (event.type === 'submit') {
          const form = event.target instanceof HTMLFormElement ? event.target : event.target.closest?.('form');
          if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.action || '')) return;
          if (form.closest('cube-craft') || !document.body.contains(this)) return;
          event.preventDefault();
          event.stopPropagation();
          this._addToCart();
          return;
        }
        if (!isOurAtcButton(event.target)) return;
        event.preventDefault();
        event.stopPropagation();
        this._addToCart();
      };
      document.addEventListener('click', guard, true);
      document.addEventListener('submit', guard, true);
    }

    _findVariant(contains, excludes) {
      return (
        this.variants.find(
          (v) => includesAny(v.title, contains) && excludesAny(v.title, excludes || [])
        ) || null
      );
    }

    _currentOption() {
      return this.options.find((o) => o.id === this.optionId) || this._optionsForEnv(this.environment)[0] || null;
    }

    _resolved() {
      const opt = this._currentOption();
      const base = opt ? this._findVariant(opt.baseContains, opt.baseExcludes) : null;
      return { opt, base };
    }

    _setStatus(msg, tone) {
      if (!this.statusEl) return;
      if (!msg) {
        this.statusEl.hidden = true;
        this.statusEl.textContent = '';
        return;
      }
      this.statusEl.hidden = false;
      this.statusEl.textContent = msg;
      this.statusEl.dataset.tone = tone || 'success';
    }

    _sync() {
      const i18n = this.i18n;
      const { opt, base } = this._resolved();

      this.envPills?.querySelectorAll('[data-cb-env]').forEach((btn) => {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-cb-env') === this.environment ? 'true' : 'false');
      });
      this.modelPills?.querySelectorAll('[data-cb-model]').forEach((btn) => {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-cb-model') === this.optionId ? 'true' : 'false');
      });

      if (this.descEl) this.descEl.innerHTML = opt?.description || '';

      const cents = Number(base?.price) || 0;
      if (this.basePriceEl) this.basePriceEl.textContent = moneyOf(base, this.moneyFormat);
      if (this.totalEl) this.totalEl.textContent = formatMoney(cents, this.moneyFormat);

      if (base?.id) {
        const input = document.querySelector(`form[action*="/cart/add"] [name="id"]`);
        if (input) {
          input.value = String(base.id);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    async _addToCart() {
      const i18n = this.i18n;
      const { opt, base } = this._resolved();
      if (!base?.id || !base.available) {
        this._setStatus(t(i18n, 'variantMissing', 'Varyant bulunamadı.'), 'error');
        return;
      }

      const fd = new FormData();
      fd.append('items[0][id]', String(base.id));
      fd.append('items[0][quantity]', '1');
      fd.append(`items[0][properties][${t(i18n, 'propType', 'Ürün Tipi')}]`, 'Led Sihirli Küp');
      fd.append(
        `items[0][properties][${t(i18n, 'propEnvironment', 'Ortam')}]`,
        opt?.environment === 'outdoor' ? t(i18n, 'outdoor', 'Dış mekan') : t(i18n, 'indoor', 'İç mekan')
      );
      fd.append(
        `items[0][properties][${t(i18n, 'propModel', 'Model')}]`,
        `${opt?.label || ''} — ${opt?.sizeLabel || ''}`.trim()
      );
      fd.append(`items[0][properties][${t(i18n, 'propSides', 'Ekran')}]`, opt?.sides || '');

      const sectionIds = cartSectionIds();
      if (sectionIds.length) fd.append('sections', sectionIds.join(','));

      this._setStatus(t(i18n, 'adding', 'Ekleniyor…'), 'success');
      try {
        const res = await fetch(cartAddUrl(), {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json' },
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || t(i18n, 'addError', 'Sepete eklenemedi.'));
        }
        this._setStatus(t(i18n, 'added', 'Sepete eklendi.'), 'success');
        await notifyHorizonCart(data, [{ merchandiseId: String(base.id), quantity: 1 }]);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data, bubbles: true }));
      } catch (err) {
        console.error('[CubeCraft]', err);
        this._setStatus(err.message || t(i18n, 'addError', 'Sepete eklenemedi.'), 'error');
      }
    }
  }

  if (!customElements.get('cube-craft')) {
    customElements.define('cube-craft', CubeCraft);
  }
})();
